<template>
  <section class="passe-livre">
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        Dados Pessoais
        <v-btn
          depressed
          small
          color="error"
          v-on:click="logout()"
          class="btn-logout"
        >
          <v-icon>exit_to_app</v-icon>Sair
        </v-btn>
      </v-card-title>
      <v-card-text class="app-card-content">
        <article class="passe-livre-card">
          <section class="passe-livre-card-content" v-if="beneficiario">
            <v-row no-gutters>
              <v-col :md="5" :sm="5" :xs="12" cols="12" class="mt-2">
                <strong class="info-text">
                  Nome:
                  <em>{{ beneficiario.nome }}</em>
                </strong>
              </v-col>
              <v-col
                :md="3"
                :sm="3"
                :xs="12"
                cols="12"
                class="mt-2 text-md-left"
              >
                <strong class="info-text">
                  CPF:
                  <em>{{ beneficiario.cpf | cpf }}</em>
                </strong>
              </v-col>
              <v-col
                :md="4"
                :sm="4"
                :xs="12"
                cols="12"
                class="mt-2 text-sm-right"
              >
                <strong class="info-text">
                  Nascimento:
                  <em>{{ beneficiario.dataNascimento | date }}</em>
                </strong>
              </v-col>
              <v-col :md="5" :sm="5" :xs="12" cols="12" class="mt-3">
                <strong class="info-text">
                  Sexo:
                  <em>{{ beneficiario.sexo | sexo }}</em>
                </strong>
              </v-col>
              <v-col
                :md="3"
                :sm="3"
                :xs="12"
                cols="12"
                class="mt-3 text-md-left"
              >
                <strong class="info-text">
                  Telefone:
                  <em>
                    ({{ beneficiario.dddTelefone }})
                    {{ beneficiario.telefone }}
                  </em>
                </strong>
              </v-col>
            </v-row>
            <a
              href="#"
              @click.prevent.stop="dialogEditForm = true"
              title="Editar Informações"
              >Editar Endereço/Contato</a
            >
          </section>
        </article>
      </v-card-text>
    </v-card>

    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">Processos</v-card-title>
      <v-card-text class="app-card-content">
        <v-alert color="primary" dark border="left" prominent>
          <h4
            style="font-weight: bold !important;
    margin: 0px;"
          >
            Atenção!
          </h4>
          <p>
            De acordo com a resolução da ARCE Nº 267, de 09 de Junho de 2020, é
            prorrogado por seis meses, a contar dos respectivos vencimentos, a
            admissão, pelo sistema de bilhetagem eletrônica utilizada pelas
            transportadoras, das carteiras do Passe Livre Intermunicipal, que
            venceram ao longo do ano de 2020 e que vierem a vencer em razão da
            ausência de renovação cadastral do beneficiário.
          </p>
        </v-alert>
        <br />
        <article class="passe-livre-card">
          <v-layout v-resize="onResize" column>
            <section class="passe-livre-card-content">
              <v-data-table
                :headers="table.headers"
                :items="table.processos"
                :loading="isLoadingProcess"
                :hide-default-header="isMobile"
                :class="{ mobile: isMobile }"
                hide-default-footer
              >
                <template v-if="table.processos.length" v-slot:body="{ items }">
                  <tbody>
                    <template v-for="(item, index) in items">
                      <tr v-if="!isMobile" :key="index">
                        <td>{{ item.id }}</td>
                        <td>{{ item.tipoProcesso.descricao }}</td>
                        <td>{{ item.tipoAtendimento.descricao }}</td>
                        <td width="130px">
                          <v-btn-toggle>
                            <v-btn
                              small
                              title="Acompanhar Processo"
                              color="#FFA000"
                              v-on:click="loadAcompanhamentos(item.id)"
                            >
                              <v-icon size="15px" class="white--text"
                                >autorenew</v-icon
                              >
                            </v-btn>
                            <v-btn
                              small
                              title="Imprimir Documentos"
                              color="#0091EA"
                              @click="getDocument(beneficiario.id)"
                              v-if="
                                hasInclusion(item) && hasFinishedRegister(item)
                              "
                            >
                              <v-icon size="15px" class="white--text"
                                >assignment</v-icon
                              >
                            </v-btn>
                            <v-btn
                              small
                              title="Editar Cadastro"
                              color="#00C853"
                              @click="goEditPage(item.id)"
                              v-if="
                                hasInclusion(item) && !hasFinishedRegister(item)
                              "
                            >
                              <v-icon size="15px" class="white--text"
                                >edit</v-icon
                              >
                            </v-btn>
                          </v-btn-toggle>
                        </td>
                      </tr>
                      <tr v-else :key="index">
                        <td class="th-mobile">
                          <ul class="flex-content">
                            <li class="flex-item">
                              <strong>Código</strong>
                              <span>{{ item.id }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Tipo Processo</strong>
                              <span>{{ item.tipoProcesso.descricao }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Tipo Atendimento</strong>
                              <span>{{ item.tipoAtendimento.descricao }}</span>
                            </li>
                            <li class="flex-item">
                              <strong>Ações</strong>
                              <v-btn-toggle>
                                <v-btn
                                  small
                                  title="Acompanhar Processo"
                                  color="#FFA000"
                                  v-on:click="loadAcompanhamentos(item.id)"
                                >
                                  <v-icon size="15px" class="white--text"
                                    >autorenew</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  small
                                  title="Imprimir Documentos"
                                  color="#0091EA"
                                  @click="getDocument(beneficiario.id)"
                                  v-if="
                                    hasInclusion(item) &&
                                      hasFinishedRegister(item)
                                  "
                                >
                                  <v-icon size="15px" class="white--text"
                                    >assignment</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  small
                                  title="Editar Cadastro"
                                  color="#00C853"
                                  @click="goEditPage(item.id)"
                                  v-if="
                                    hasInclusion(item) &&
                                      !hasFinishedRegister(item)
                                  "
                                >
                                  <v-icon size="15px" class="white--text"
                                    >edit</v-icon
                                  >
                                </v-btn>
                              </v-btn-toggle>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>

                <template v-if="isLoadingProcess" v-slot:progress>
                  <v-progress-linear indeterminate></v-progress-linear>
                </template>

                <template v-if="!table.processos.length" v-slot:no-data
                  >Não a itens disponíveis</template
                >
              </v-data-table>
            </section>
          </v-layout>
        </article>
      </v-card-text>
    </v-card>

    <div class="text-center">
      <v-dialog v-model="dialog" width="900">
        <v-card
          class="app-card app-card--without-border app-card--without-margin-bottom"
        >
          <v-card-title class="app-card-title" primary-title
            >Acompanhamento de Processo</v-card-title
          >
          <v-card-text
            class="app-card-content"
            style="height: 360px; overflow: auto;"
          >
            <v-timeline
              :dense="true"
              v-if="acompanhamentos && acompanhamentos.length"
            >
              <v-timeline-item
                v-for="(acompanhamento, index) in acompanhamentos"
                :key="index"
                color="light-blue darken-4"
                small
                fill-dot
                icon="done"
              >
                <v-alert
                  :value="true"
                  dense
                  border="left"
                  color="light-blue darken-3"
                  dark
                  class="white--text"
                >
                  <p>
                    <strong>Situação:</strong>
                    {{ acompanhamento.situacao.descricao }}
                  </p>
                </v-alert>
              </v-timeline-item>
            </v-timeline>
            <p v-else>No momento não existe tramitação para esse processo.</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed outlined color="error" @click="dialog = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDocument" width="900">
        <v-card class="app-card" style="margin-bottom:0px;">
          <v-card-title class="app-card-title">Ficha de Inscrição</v-card-title>
          <v-card-text class="app-card-content">
            <div style="height: 460px;">
              <v-alert type="info"
                >Faça o Download da ficha de inscrição.</v-alert
              >
              <p>
                Caso não consiga visualizar a ficha,
                <a :href="urlDocument" target="_blank">Clique Aqui</a>
              </p>
              <iframe
                :src="urlDocument"
                frameborder="0"
                style="width: 100%; height: 374px;"
              ></iframe>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="error" @click="dialogDocument = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEditForm" width="900">
        <EditForm
          v-if="dialogEditForm"
          @closeDialogEditForm="closeDialogEditForm"
        />
      </v-dialog>
    </div>
  </section>
</template>

<script>
import BeneficiarioModule from "@/store/modules/beneficiario";
import { Beneficiario } from "../../../models/beneficiario";
import BeneficiarioService from "@/services/beneficiario.service";
import BeneficiarioAuthService from "@/services/beneficiarioCearaApp.auth.service";
import GlobalStore from "@/store/modules/global";
import moment from "moment";
import { VUE_APP_REPORT_URL } from "@/commons/config";
import EditForm from "./EditForm";

export default {
  components: {
    EditForm
  },
  data() {
    return {
      dialogEditForm: false,
      dialog: false,
      dialogDocument: null,
      urlDocument: null,
      beneficiario: null,
      table: {
        headers: [
          { text: "Processo", value: "processo" },
          { text: "Tipo Processo", value: "t_processo" },
          { text: "Tipo Atendimento", value: "t_atendimento" },
          { text: "Ações", value: "acoes" }
        ],
        processos: []
      },
      acompanhamentos: [],
      isLoadingAcompanhamentos: false,
      isLoadingProcess: false,
      isMobile: false
    };
  },
  methods: {
    logout() {
      BeneficiarioAuthService.logout();
    },
    loadData() {
      const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();
      if (beneficiario) {
        BeneficiarioService.findByCpfNascimento(
          beneficiario.cpf,
          beneficiario.dataNascimento
        ).subscribe(res => {
          this.beneficiario = res;
          this.loadProcessos();
        });
      }
    },
    loadProcessos() {
      this.isLoadingProcess = true;
      BeneficiarioService.beneficiarioProcessos(this.beneficiario.id).subscribe(
        res => {
          this.table.processos = res.reverse();
          this.isLoadingProcess = false;
        },
        err => {
          GlobalStore.setSnackBar({
            show: true,
            message: "Erro ao tentar buscar processos",
            type: "error"
          });
          this.isLoadingProcess = false;
        }
      );
    },
    loadAcompanhamentos(processoId) {
      this.isLoadingAcompanhamentos = true;
      BeneficiarioService.beneficiarioProcessoAcompanhamentos(
        processoId
      ).subscribe(
        res => {
          this.acompanhamentos = res;
          this.dialog = true;
          this.isLoadingAcompanhamentos = false;
        },
        err => {
          GlobalStore.setSnackBar({
            show: true,
            message: "Algo Deu errado ao tentar buscar os acompanhamentos",
            type: "error"
          });
          this.isLoadingAcompanhamentos = false;
        }
      );
    },
    goEditPage(idProcesso) {
      this.$router.push({
        name: "ceara-app-passe-livre-edit-cadastro",
        params: { id: this.beneficiario.id, processo: idProcesso }
      });
    },
    getDocument(processoId) {
      // todo: melhorar chamada dessa url para o openreport
      this.urlDocument = `${VUE_APP_REPORT_URL}?p=BENEFICIARIO_ID--${processoId}---nome--sit_passe_livre_confirmacao_cadastro---sys--sit_passe_livre_confirmacao_cadastro`;
      //this.dialogDocument = true;
      window.open(this.urlDocument);
    },
    hasInclusion(processo) {
      return BeneficiarioAuthService.hasInclusionProcess(processo);
    },
    hasFinishedRegister(processo) {
      return BeneficiarioAuthService.hasFinishedRegister(processo);
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    closeDialogEditForm(event) {
      this.dialogEditForm = event;
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
.passe-livre {
  .btn-logout {
    float: right;
    position: absolute;
    right: 20px;
  }
  &-card {
    margin-bottom: 15px;
    &-title {
      font-size: 17px !important;
      font-weight: bold !important;
      border-bottom: solid 1px #efefef;
    }
    &-content {
      .info-text {
        font-size: 14px;
        em {
          font-style: normal;
          font-weight: 400;
        }
      }
    }
  }
}

.headline {
  font-size: 15px !important;
}
</style>
